(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/hooks/use-customer-preferences.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/hooks/use-customer-preferences.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const getCustomersPreferencesAsync = svs.ticketsOrderHome.services.getCustomersPreferencesAsync;
const useCustomerPreferences = () => {
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  const _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    const fetchCustomerInfo = async () => {
      try {
        const _await$getCustomersPr = await getCustomersPreferencesAsync(),
          playerPreferences = _await$getCustomersPr.playerPreferences,
          error = _await$getCustomersPr.error;
        if (mounted.current) {
          setData(playerPreferences);
          setError(error);
        }
      } catch (err) {
        mounted.current && setError(err);
      } finally {
        mounted.current && setLoading(false);
      }
    };
    fetchCustomerInfo();
    return () => {
      mounted.current = false;
    };
  }, []);
  return {
    data,
    error,
    loading
  };
};
setGlobal('svs.ticketsOrderHome.hooks.useCustomerPreferences', useCustomerPreferences);

 })(window);